import { Controller } from "@hotwired/stimulus"

// Opens course content images full-screen in a dimmed overlay (lightbox).
// Mounted on the lesson reader; clickable images carry
// data-action="click->image-lightbox#open". Closes on a backdrop click, the
// close button, or Escape; locks body scroll while open and restores focus to
// the image that was clicked.
export default class extends Controller {
  static targets = ["overlay", "image", "caption", "closeButton"]

  open(event) {
    const trigger = event.currentTarget
    const source = trigger.dataset.lightboxSrc || trigger.currentSrc || trigger.src
    if (!source) return

    this.imageTarget.src = source
    this.imageTarget.alt = trigger.alt || ""

    const caption = trigger.dataset.lightboxCaption || trigger.alt || ""
    this.captionTarget.textContent = caption
    this.captionTarget.hidden = caption.length === 0

    this.lastFocused = trigger
    this.overlayTarget.hidden = false
    this.overlayTarget.setAttribute("aria-hidden", "false")
    // Add the visible class on the next frame so the opacity transition runs
    // from the just-unhidden state instead of being skipped.
    requestAnimationFrame(() => this.overlayTarget.classList.add("is-open"))
    document.body.style.overflow = "hidden"
    this.closeButtonTarget.focus()
  }

  close() {
    if (this.overlayTarget.hidden) return

    this.overlayTarget.classList.remove("is-open")
    this.overlayTarget.hidden = true
    this.overlayTarget.setAttribute("aria-hidden", "true")
    this.imageTarget.removeAttribute("src")
    document.body.style.overflow = ""
    if (this.lastFocused) this.lastFocused.focus()
  }

  // Close only when the dimmed backdrop itself is clicked — clicking the image
  // (a child of the overlay) should keep the lightbox open.
  backdropClose(event) {
    if (event.target === this.overlayTarget) this.close()
  }

  closeOnEscape() {
    if (!this.overlayTarget.hidden) this.close()
  }
}
